import {apiBase} from 'api/base.js';

class CowDeleteAPI {
  create(params) {
    return apiBase.post('/admin/cow_delete', params);
  }
}

export const cowDeleteAPI = new CowDeleteAPI();
